<template>
    <div> 
        <table class="table table-sm">
        <thead>
        <tr>                     
            <th >SEDE DI PROVENIENZA</th>
            <th >DATA</th>
            <th >NUMERO PRODOTTI</th>                                  
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,index) in messages" :key="index">
            <td style="color:blue">{{ item.description1 }}</td>                    
            <td >{{ item.date }}</td>    
            <td >{{ item.total_qty }}</td>                                                                              
        </tr>                    
        </tbody>
        </table>                     
</div>
    
</template>
 <script>
  
   export default {
    props:['messages'],
    data() {
      return {
      }
    },
  }

</script>
<style scoped>

  
 td{
  
    color       : black;
  
 } 

 

  </style>